export default function ToggleSwitch({
  checked = false,
  onChange,
  label = "",
  disabled = false,
  compact = false,
  className = "",
  checkedSymbol,
  uncheckedSymbol,
  ariaLabel,
  alwaysCheckedLook = false,
  alwaysUncheckedLook = false,
  trackOnColor = "#166534",
  trackOffColor = "#39210d",
  plain = false,
  height = 25,
}) {
  const handleToggle = () => {
    if (disabled) return;
    if (onChange) {
      onChange(!checked);
    }
  };

  const useSymbols = checkedSymbol != null || uncheckedSymbol != null;
  const showCheckedMark = alwaysUncheckedLook
    ? false
    : alwaysCheckedLook || checked;
  const symbol = checked ? checkedSymbol : uncheckedSymbol;
  const markColor = disabled ? "#666" : showCheckedMark ? trackOnColor : trackOffColor;
  const trackOn = !alwaysUncheckedLook && (alwaysCheckedLook || checked);
  const trackColor =
    disabled && trackOnColor === "#166534" && trackOffColor === "#39210d"
      ? "#999"
      : trackOn
        ? trackOnColor
        : trackOffColor;
  const knob = 20;
  const inset = (height - knob) / 2;

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: compact ? 0 : "10px",
      }}
    >
      {label && (
        <span style={{ fontSize: "calc(14px * var(--text-scale, 1))", color: "#39210d", opacity: disabled ? 0.5 : 1 }}>
          {label}
        </span>
      )}
      <div
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel || label || undefined}
        style={{
          height: `${height}px`,
          width: "50px",
          flex: "0 0 50px",
          background: trackColor,
          position: "relative",
          borderRadius: "50px",
          boxShadow: `0 0 2px ${trackColor}`,
          transition: "400ms all ease-in-out 50ms",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.55 : 1,
        }}
        onClick={handleToggle}
      >
        <label
          style={{
            height: "20px",
            width: "20px",
            background: "rgba(255, 255, 255, 1)",
            position: "absolute",
            top: `${inset}px`,
            left: checked ? `${50 - inset - knob}px` : `${inset}px`,
            cursor: disabled ? "not-allowed" : "pointer",
            borderRadius: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "400ms all ease-in-out 50ms",
            transform: useSymbols || alwaysCheckedLook ? "none" : checked ? "rotate(360deg)" : "rotate(0deg)",
          }}
        >
          {plain ? null : useSymbols ? (
            <span
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontSize: "calc(11px * var(--text-scale, 1))",
                fontWeight: 700,
                lineHeight: 1,
                color: markColor,
                userSelect: "none",
                pointerEvents: "none",
              }}
            >
              {symbol}
            </span>
          ) : (
            <>
              <span
                style={{
                  content: '""',
                  height: showCheckedMark ? "12.5px" : "15px",
                  width: "1.25px",
                  position: "absolute",
                  top: showCheckedMark ? "calc(55% - 6.25px)" : "calc(50% - 7.5px)",
                  left: showCheckedMark ? "calc(60% - 0.625px)" : "calc(50% - 0.625px)",
                  transform: "rotate(45deg)",
                  background: markColor,
                  borderRadius: "5px",
                  transition: "400ms all ease-in-out 50ms",
                }}
              />
              <span
                style={{
                  content: '""',
                  height: "1.25px",
                  width: showCheckedMark ? "5px" : "15px",
                  position: "absolute",
                  top: showCheckedMark ? "calc(95% - 6.25px)" : "calc(50% - 0.625px)",
                  left: showCheckedMark ? "calc(22.5% - 0.625px)" : "calc(50% - 7.5px)",
                  transform: "rotate(45deg)",
                  background: markColor,
                  borderRadius: "5px",
                  transition: "400ms all ease-in-out 50ms",
                }}
              />
            </>
          )}
        </label>
      </div>
    </div>
  );
}
